'use client';

import cx from 'classnames';
import { AnimatePresence } from 'motion/react';
import * as m from 'motion/react-m';
import { Attributes, ReactElement, ReactNode, cloneElement } from 'react';
import { useFormContext } from 'react-hook-form';

import styles from './formItem.module.scss';

interface Props {
  id?: string;
  label?: ReactNode;
  name?: string;
  error?: string;
  description?: string | ReactNode[];
  withoutExplain?: boolean;
  className?: string;
  children: ReactElement;
  inheritLabel?: boolean;
}

export const FormItem = ({
  id,
  label,
  name,
  error,
  description,
  withoutExplain,
  inheritLabel,
  className,
  children,
}: Props) => {
  const { register } = useFormContext() ?? {};
  const isShowExplain = !withoutExplain && !!(error || description);

  return (
    <div className={cx(styles.wrapper, className)}>
      {label && (
        <div className={cx(styles.labelWrapper, { [styles.inheritLabel]: inheritLabel })}>
          <label htmlFor={id}>{label}</label>
        </div>
      )}
      <div className={styles.controlWrapper}>
        {cloneElement(children, {
          id,
          isError: error !== undefined ? !!error : undefined,
          ...(name ? register?.(name) : undefined),
        } as Attributes)}
        <AnimatePresence mode='popLayout' initial={!description}>
          {isShowExplain && (
            <m.div
              key={error || 'description'}
              initial={{ y: -2, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 4, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className={cx(styles.explain, { [styles.isError]: error })}
            >
              <p>{error || description}</p>
            </m.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};
